import React from "react";
import { Radio } from "antd";
import { useTranslation } from "react-i18next";
import { useSearch } from "../../../../../contexts/SearchContext";
import "./FlightTripTypeToggle.css";

/** RoundTrip / OneWay — רק בורר קומפקטי (ללא כותרת שלב או טקסט הסבר). */
export default function FlightTripTypeToggle({ className = "" }) {
  const { t, i18n } = useTranslation();
  const { flightTripType, setFlightTripType } = useSearch();
  const he = i18n.language?.toLowerCase().startsWith("he");

  return (
    <Radio.Group
      className={`flight-trip-type-toggle flight-trip-type-toggle--compact ${className}`.trim()}
      value={flightTripType}
      onChange={(e) => setFlightTripType(e.target.value)}
      optionType="button"
      buttonStyle="solid"
      size="middle"
      dir="rtl"
    >
      <Radio.Button value="RoundTrip">
        {t("flightsearch.tripType.roundTrip", {
          defaultValue: he ? "הלוך-חזור" : "Round trip",
        })}
      </Radio.Button>
      <Radio.Button value="OneWay">
        {t("flightsearch.tripType.oneWay", {
          defaultValue: he ? "כיוון אחד" : "One way",
        })}
      </Radio.Button>
    </Radio.Group>
  );
}
